import React, {useState, useEffect} from "react";
import Accordion from "../../components/accordion/Accordion";
import {cleanDrops} from "../../hooks/helpers";
import {useLocation, useHistory} from "react-router-dom";
import AddCourseModal from "./components/AddModal";
import HeadView from "../../containers/HeadView";
import {ButtonWithIcon} from "../../styles/Butttons";
import {ReactComponent as PlusIcon} from "../../assets/icons/plus.svg";
import ImgEncabezado from "../../components/imagenEncabezado/ImgEncabezado";
import CoursesList from "./components/CoursesList";
import AppLoader from "../../components/loaders/Loader";
import EssentialProvider from "../../context/EssentialProvider";

function useQuery() {
   return new URLSearchParams(useLocation().search);
}

function EssentialCoursesView({theme}) {
   const [status, setStatus] = useState([0, 0]);
   const [showModal, setShowModal] = useState(false);
   const [showAddSuccess, setAddSuccess] = useState(false);
   const [isLoading, setLoading] = useState({data: true, all: false});
   const [data, setData] = useState([]);

   let location = useLocation();
   let query = useQuery();
   let history = useHistory();

   useEffect(() => {
      setShowModal(!!query.get("addModal"));
   }, []);

   useEffect(() => {
      let dataN = [...datExample];
      setData(dataN);
      setLoading({...isLoading, data: false});
   }, []);

   const changeMode = (newVal, key) => {
      let nStatus = cleanDrops(status.length, key, newVal);
      setStatus([...nStatus]);
   };
   const closeModal = () => {
      history.replace(location.pathname);
      setShowModal(false);
      setAddSuccess(false);
   };
   const openModal = () => {
      history.push("/offer/add/1");
      setShowModal(true);
   };

   const save = (data) => {
      console.log("adas", data);
      setAddSuccess(true);
   };

   const toggleChange = (val, target, key) => {
      // setLoading({...isLoading, page: true});
      let dataN = [...data];
      const newData = dataN.map((item) => {
         if (item.id === key) {
            return {...item, [target]: val};
         }
         return item;
      });
      setData(newData);
      /* setTimeout(() => {
         setLoading({...isLoading, page: false});
      }, 10); */
   };

   const deleteItem = (id) => {
      console.log("dsadas", id);
      let newAdminList = data.filter((item) => item.id !== id);
      setData(newAdminList);
   };

   return (
      <>
         <HeadView>
            <></>
            <>
               <ButtonWithIcon action={openModal} text="Crear nuevo curso" Icon={PlusIcon} />
            </>
         </HeadView>
         <ImgEncabezado
            theme={theme}
            title="Imagenes encabezado para cursos esenciales"
            status={status[0]}
            changeMode={(val) => changeMode(val, 0)}
            titleDesc="Descripción general para Cursos Esenciales"
            idUpdate={1}
            linkWeb="cursos_esenciales"
            nameUpdate="Essentials"
         />
         <Accordion theme={theme} title="lista de cursos esenciales" status={status[1]} changeMode={(val) => changeMode(val, 1)}>
            <CoursesList theme={theme} isLoading={isLoading.data} data={data} toggleChange={toggleChange} deleteItem={deleteItem} />
         </Accordion>

         <AddCourseModal showSuccess={showAddSuccess} close={closeModal} save={save} isOpen={showModal} theme={theme} />
         <AppLoader theme={theme} isVisible={isLoading.page} />
      </>
   );
}

export default EssentialCoursesView;

const datExample = [
   {
      id: 1,
      name: "Nombre del curso",
      facilitator: "Nombre de los expositores",
      code: "aA8i2",
      date: "12/05/2020",
      onpage: false,
      onhome: false,
   },
   {
      id: 2,
      name: "Nombre del curso",
      facilitator: "Nombre de los expositores",
      code: "aA8i2",
      date: "12/05/2020",
      onpage: true,
      onhome: true,
   },
   {
      id: 4,
      name: "Nombre del curso",
      facilitator: "Nombre de los expositores",
      code: "aA8i2",
      date: "12/05/2020",
      onpage: false,
      onhome: false,
   },
   {
      id: 6,
      name: "Nombre del curso",
      facilitator: "Nombre de los expositores",
      code: "aA8i2",
      date: "12/05/2020",
      onpage: false,
      onhome: false,
   },
   {
      id: 8,
      name: "Nombre del curso",
      facilitator: "Nombre de los expositores",
      code: "aA8i2",
      date: "12/05/2020",
      onpage: true,
      onhome: false,
   },
];
